<ul *ngIf="length" class="uk-pagination uk-flex-center" [ngClass]="{ 'column-center-small': navOpen }">
  <li [ngClass]="{ 'not-allowed': !hasPreviousPage() }">
    <a class="uk-flex uk-flex-middle" (click)="previousPage()" [ngClass]="{ 'uk-disabled': !hasPreviousPage() }">
      <span class="margin-small-right" uk-pagination-previous></span>

      <span i18n="@@Previous">Previous</span>
    </a>
  </li>

  <li *ngFor="let number of getNumberOfPages() | numberIterator | paginationPages: pageIndex">
    <ng-container *ngIf="number === pageIndex + 1; else template">
      <span [ngClass]="{ 'uk-active not-allowed active-page-number': number === pageIndex + 1 }">{{ number }}</span>
    </ng-container>

    <ng-template #template>
      <ng-container *ngIf="number !== 0; else ellipsis">
        <a [ngClass]="{ 'hide-small-screen': navOpen }" (click)="selectPage(number - 1)">{{ number }}</a>
      </ng-container>

      <ng-template #ellipsis>
        <span [ngClass]="{ 'hide-small-screen': navOpen }">...</span>
      </ng-template>
    </ng-template>
  </li>

  <li [ngClass]="{ 'not-allowed': !hasNextPage() }">
    <a class="uk-flex uk-flex-middle" (click)="nextPage()" [ngClass]="{ 'uk-disabled': !hasNextPage() }">
      <span class="margin-small-right" i18n="@@Next">Next</span>

      <span uk-pagination-next></span>
    </a>
  </li>
</ul>
